import { TRIGGER_FETCH_TXN_LIST_API_SUCCESS, CLEAR_TXN_LIST } from 'redux/actionTypes';

const initialState = {
	txnList: [],
};

// export const locale[];

const TxnListReducer = (state = initialState, action) => {
	switch (action.type) {
		case TRIGGER_FETCH_TXN_LIST_API_SUCCESS:
			return {
				...state,
				...action.data,
				...(!action.data?.dontAppend
					? { txnList: [...state.txnList, ...action.txnList] }
					: { txnList: [...action.txnList] }),
			};

		case CLEAR_TXN_LIST:
			return {
				...state,
				txnList: [],
			};
		default:
			return state;
	}
};

export default TxnListReducer;
